import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuStylingOption} from '@Components/contextual-menu/components/contextual-menu-styling-option';
import type {IconStates} from '@Components/contextual-menu/components/styling-options';
import {LetterCase} from '@Utils/string.util';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import type {TranscriptLetterCaseOptionProps} from '@Components/poster-editor/components/poster-editing-side-panel/components/transcript-letter-case-option/transcript-letter-case-option.types';
import {IconSize} from '@Components/icon-v2/icon.types';

export function TranscriptLetterCaseOption({showLargeIcons = false}: TranscriptLetterCaseOptionProps): ReactElement<any> {
  const activeItem = useGetSelectedTranscriptItem();
  if (activeItem === null) {
    throw new Error('Transcript Item is undefined in TranscriptLetterCaseOption');
  }

  const updateAppliedLetterCase = async (letterCase: LetterCase): Promise<void> => {
    await activeItem.updateAllSubtitlesToLetterCase(letterCase);
  };

  const getLetterCaseOptionsData = (): IconStates[] => {
    return [
      {
        id: LetterCase.LOWER_CASE,
        icon: 'icon-lower-case',
        isSelected: false,
        iconSize: showLargeIcons ? IconSize.SIZE_ICON_24 : IconSize.SIZE_ICON_16,
      },
      {
        id: LetterCase.SENTENCE_CASE,
        icon: 'icon-sentence-case',
        isSelected: false,
        iconSize: showLargeIcons ? IconSize.SIZE_ICON_24 : IconSize.SIZE_ICON_16,
      },
      {
        id: LetterCase.UPPER_CASE,
        icon: 'icon-upper-case',
        isSelected: false,
        iconSize: showLargeIcons ? IconSize.SIZE_ICON_24 : IconSize.SIZE_ICON_16,
      },
    ];
  };

  return (
    <ContextualMenuStylingOption
      id="subtitle-text-letter-case-option"
      label={window.i18next.t('pmwjs_letter_case')}
      data={getLetterCaseOptionsData()}
      onClick={updateAppliedLetterCase}
    />
  );
}
